export default "__VITE_ASSET__BUA8N_n0__"